import { PersonaId } from '../../../models/PersonaId';

/**
 * @public
 */
export interface PersonaRequestBody {
  personaId: PersonaId;
}
